webpackJsonp([200019860562359],{

/***/ 1216:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"htmlAst":{"type":"root","children":[{"type":"element","tagName":"h2","properties":{},"children":[{"type":"text","value":"Uitleg"}]},{"type":"text","value":"\n"},{"type":"element","tagName":"p","properties":{},"children":[{"type":"text","value":"Er is helaas geen trucje dat je kunt leren om de persoonlijke voornaamwoorden te benoemen. Ze zijn behoorlijk onregelmatig. Het enige wat erop zit is om de "},{"type":"element","tagName":"a","properties":{"href":"/spqr/rijtjes/persoonlijk-voornaamwoord?les=2"},"children":[{"type":"text","value":"rijtjes"}]},{"type":"text","value":" goed te leren."}]}],"data":{"quirksMode":false}},"frontmatter":{"book":"spqr","leerdoel":"2h","title":"Leerdoel 2h"}}},"pathContext":{"slug":"/spqr/leerdoelen/2h/","title":"Leerdoel 2h"}}

/***/ })

});


// WEBPACK FOOTER //
// path---spqr-leerdoelen-2-h-c2e606dd4735d3ecd46e.js